import React, { useState } from 'react';
import styles from './OurBlog.module.css';
import imge from '../BlogPosts/Rectangle_4449.webp';
import imge1 from '../BlogPosts/Rectangle_4448.webp';
import imge2 from '../BlogPosts/Rectangle_4455.webp';
import imge3 from '../BlogPosts/Rectangle_4456.webp';

import imge4 from '../OurBlog/photo-1512621776951-a57141f2eefd.jpeg';
import imge5 from '../OurBlog/photo-1598103442097-8b74394b95c6.jpeg';

const OurBlog = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const blogPosts = [
    {
      id: 1,
      title: "We give ourselves an Italian taste",
      author: "By Mr Brif",
      date: "Mar 01, 22",
      image: imge,
      excerpt: "On a cloudy day like today, I wanted to talk to you about this Carbonara Sauce, a luxury and one of the simplest...",
      category: "breakfast"
    },
    {
      id: 2,
      title: "Waldorf - the star original salad",
      author: "By Mr Brif",
      date: "Mar 01, 22",
      image:imge1,
      excerpt: "Welcome to Paulina Cocina, dearest human inhabitants of the world. In this edition, where you will find a spectacular recipe to make a Waldorf Salad, that did!",
      category: "salads"
    },
    {
      id: 3,
      title: "Pesto Bacon Burger, New Taste",
      author: "By Mr Brif",
      date: "Mar 01, 22",
      image: imge2,
      excerpt: "They solve the matter with a bit of frio paper, and I assure you they are divine...",
      category: "burgers"
    },
    {
      id: 4,
      title: "Mix Brif",
      author: "By Mr Brif",
      date: "Mar 01, 22",
      image: imge3,
      excerpt: "We give ourselves an Italian...",
      category: "drinks"
    },
    {
      id: 5,
      title: "Waldorf - the star original",
      author: "By Mr Brif",
      date: "Mar 01, 22",
      image:imge4,
      excerpt: "Waldorf - the star original...",
      category: "salads"
    },
    {
      id: 6,
      title: "Pasta Bacon Burger, New Taste",
      author: "By Mr Brif",
      date: "Mar 01, 22",
      image:imge5,
      excerpt: "Pasta Bacon Burger, New Taste...",
      category: "pasta"
    },
    {
      id: 7,
      title: "Cheese For New Taste",
      author: "By Mr Brif",
      date: "Mar 01, 22",
      image: imge3,
      excerpt: "Cheese For New Taste...",
      category: "recipe"
    }
  ];

//   const categories = ["Breakfast", "Burgers", "Drinks", "Info", "Recipe", "Salads", "Steak", "Tacos"];

  const postsPerPage = 3;
  const totalPages = Math.ceil(blogPosts.length / postsPerPage);
  const startIndex = (currentPage - 1) * postsPerPage;
  const currentPosts = blogPosts.slice(startIndex, startIndex + postsPerPage);

  const popularPosts = [
    {
      id: 1,
      title: "We give ourselves an Italian...",
      date: "Mar 01, 2022",
      image: imge
    },
    {
      id: 2,
      title: "Waldorf - the star original...",
      date: "Mar 01, 2022",
      image: imge1
    },
    {
      id: 3,
      title: "Pasta Bacon Burger, New Taste",
      date: "Mar 01, 2022",
      image: imge2
    },
    {
      id: 4,
      title: "Cheese For New Taste",
      date: "Mar 01, 2022",
      image: imge3
    }
  ];

  return (
    <div className={styles.container}>
      {/* Header */}
      <header className={styles.header}>
        <h1 className={styles.title}>News & Career</h1>
      </header>

      {/* Main Content */}
      <div className={styles.mainContent}>
        {/* Blog Posts */}
        <div className={styles.postsSection}>
          {currentPosts.map((post) => (
            <article key={post.id} className={styles.postCard}>
              <div className={styles.postImage}>
                <img src={post.image} alt={post.title} />
              </div>
              <div className={styles.postContent}>
                <div className={styles.postMeta}>
                  <span className={styles.author}>{post.author}</span>
                  <span className={styles.date}>{post.date}</span>
                </div>
                <h2 className={styles.postTitle}>{post.title}</h2>
                <p className={styles.postExcerpt}>{post.excerpt}</p>
                {/* <button className={styles.readMoreBtn}>READ MORE</button> */}
              </div>
            </article>
          ))}
        </div>

        {/* Sidebar */}
        <aside className={styles.sidebar}>
          {/* Popular Posts */}
          <div className={styles.popularSection}>
            <h3 className={styles.sidebarTitle}>POPULAR POSTS</h3>
            <div className={styles.popularList}>
              {popularPosts.map((post) => (
                <div key={post.id} className={styles.popularItem}>
                  <img src={post.image} alt={post.title} />
                  <div className={styles.popularContent}>
                    <p className={styles.popularDate}>{post.date}</p>
                    <p className={styles.popularTitle}>{post.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Categories */}
          {/* <div className={styles.categoriesSection}>
            <h3 className={styles.sidebarTitle}>CATEGORIES</h3>
            <ul className={styles.categoriesList}>
              {categories.map((category, index) => (
                <li key={index}>{category.toLowerCase()}</li>
              ))}
            </ul>
          </div> */}
        </aside>
      </div>

      {/* Pagination */}
      <div className={styles.pagination}>
        <button className={`${styles.pageBtn} ${styles.prevBtn}`}>❮</button>
        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
          <button
            key={page}
            className={`${styles.pageBtn} ${currentPage === page ? styles.activePage : ''}`}
            onClick={() => setCurrentPage(page)}
          >
            {page}
          </button>
        ))}
        <button className={`${styles.pageBtn} ${styles.nextBtn}`}>›</button>
      </div>
    </div>
  );
};

export default OurBlog;